import { render, staticRenderFns } from "./MenuAcessoRapido.vue?vue&type=template&id=36f208e4"
import script from "./MenuAcessoRapido.vue?vue&type=script&lang=ts"
export * from "./MenuAcessoRapido.vue?vue&type=script&lang=ts"
import style0 from "./MenuAcessoRapido.vue?vue&type=style&index=0&id=36f208e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports